import { useState } from 'react';

export default function TestimonialsSection() {
  const testimonials = [
    {
      text: '"레알타드와의 파트너십을 통해 혁신적인 온라인 게임을 개발할 수 있었습니다. 그들의 창의적인 게임 디자인과 첨단 기술은 여러분의 플랫폼을 차별화하고, 사용자 경험을 혁신적으로 변화시킬 것입니다. 최신 트렌드를 반영한 게임 제공으로 시장에서의 경쟁력을 높일 수 있습니다."',
      name: 'David Thompson',
      title: 'Head of Game Development'
    },
    {
      text: '"레알타드는 고객의 요구에 맞춘 맞춤형 솔루션을 제공합니다. 그들의 전문 지식을 활용해 사용자 맞춤형 인터페이스, 안정적인 게임 환경을 구축하고, 여러분의 비즈니스 요구에 완벽하게 부합하는 솔루션을 경험해 보세요."',
      name: 'Sarah Johnson',
      title: 'Software Engineering Manager'
    },
    {
      text: '"레알타드와 협력하면 온라인 배팅 플랫폼의 보안이 크게 강화됩니다. 그들의 첨단 보안 기술과 경험은 사용자 데이터를 안전하게 보호하고, 불법적인 활동을 방지하여 신뢰할 수 있는 게임 환경을 조성합니다."',
      name: 'Michael Brown',
      title: 'Chief Security Officer'
    },
    {
      text: '"레알타드는 맞춤형 마케팅 전략을 제공하여 여러분의 플랫폼을 고객에게 효과적으로 홍보할 수 있도록 도와줍니다. 그들의 시장 분석과 타깃 마케팅 접근법은 사용자 유치 및 유지에 크게 기여할 것입니다."',
      name: 'Rajesh Kumar',
      title: 'Marketing Strategy Director'
    },
    {
      text: '"레알타드는 데이터 분석을 통해 보다 정확한 비즈니스 의사결정을 지원합니다. 사용자 행동 분석, 시장 동향 파악 등 그들의 데이터 분석 능력을 활용해 효율적인 운영 전략을 수립하세요."',
      name: 'Lucas Silva',
      title: 'Head of Data Analytics'
    },
    {
      text: '"레알타드는 사용자 경험을 향상시키는 다양한 서비스를 제공합니다. 그들의 사용자 인터페이스(UI) 및 사용자 경험(UX) 디자인 전문성을 통해 게임 플레이의 편리함과 즐거움을 극대화할 수 있습니다."',
      name: 'Hiroshi Tanaka',
      title: 'User Experience Lead'
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Realtad Partners</h2>
          <div className="flex items-center justify-center space-x-2 text-yellow-400 text-2xl">
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <i className="ri-star-fill"></i>
            <span className="text-gray-600 text-base ml-2">(20,702 reviews)</span>
          </div>
        </div>

        <div className="relative">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.slice(currentIndex, currentIndex + 3).map((testimonial, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 animate-fade-in"
              >
                <p className="text-gray-700 mb-6 leading-relaxed italic">{testimonial.text}</p>
                <div className="border-t pt-4">
                  <p className="font-bold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-600">{testimonial.title}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center mt-8 space-x-2">
            {Array.from({ length: Math.ceil(testimonials.length / 3) }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index * 3)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  currentIndex === index * 3 ? 'bg-teal-500 w-8' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
